import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

// PER-CATEGORY SACRED FEATURES
// Use exact categoryName from event.categories[].categoryName as key
export const terrainFeaturesByCategory = {
  "JMM 45K": [
    {
      title: "Volcanic Experience",
      description:
        "Run across an iconic Javanese volcanic landscape. Active and dormant volcanoes define the course with steep ascents, and raw mountain terrain that demand strength, respect, and resilience.",
    },
    {
      title: "Summit Experience",
      description:
        "The race culminates at a volcanic summit viewpoint. Reach the top as the sun rises over the mountains, an unforgettable experience where endurance meets awe.",
    },
    {
      title: "Lake View Trails",
      description:
        "Flowing the tracks overlooking pristine volcanic lakes. Cool air, open horizons, and reflective waters create moments of calm amid the challenge.",
    },
    {
      title: "Tea Plantation Paths",
      description:
        "Fast, rolling sections through historic tea plantations. Neat green contours contrast with wild volcanic terrain offering rhythm, speed, and cultural charm.",
    },
  ],
  "JMM 25K": [
  {
      title: "Volcanic Experience",
      description:
        "Run across an iconic Javanese volcanic landscape. Active and dormant volcanoes define the course with steep ascents, and raw mountain terrain that demand strength, respect, and resilience.",
    },
    {
      title: "Summit Experience",
      description:
        "The race culminates at a volcanic summit viewpoint. Reach the top as the sun rises over the mountains, an unforgettable experience where endurance meets awe.",
    },
    {
      title: "Lake View Trails",
      description:
        "Flowing the tracks overlooking pristine volcanic lakes. Cool air, open horizons, and reflective waters create moments of calm amid the challenge.",
    },
    {
      title: "Tea Plantation Paths",
      description:
        "Fast, rolling sections through historic tea plantations. Neat green contours contrast with wild volcanic terrain offering rhythm, speed, and cultural charm.",
    },
  ],
  "JMM 10K": [
   {
      title: "Volcanic Experience",
      description:
        "Run across an iconic Javanese volcanic landscape. Active and dormant volcanoes define the course with steep ascents, and raw mountain terrain that demand strength, respect, and resilience.",
    },
    {
      title: "Summit Experience",
      description:
        "The race culminates at a volcanic summit viewpoint. Reach the top as the sun rises over the mountains, an unforgettable experience where endurance meets awe.",
    },
    {
      title: "Lake View Trails",
      description:
        "Flowing the tracks overlooking pristine volcanic lakes. Cool air, open horizons, and reflective waters create moments of calm amid the challenge.",
    },
    {
      title: "Tea Plantation Paths",
      description:
        "Fast, rolling sections through historic tea plantations. Neat green contours contrast with wild volcanic terrain offering rhythm, speed, and cultural charm.",
    },
  ],
};

// Global fallback for backward compatibility
export const terrainFeatures = [
  {
    title: "Volcanic Experience",
    description:
      "Run across an iconic Javanese volcanic landscape with steep ascents and raw mountain terrain",
  },
  {
    title: "Summit Experience",
    description:
      "The race culminates at a volcanic summit viewpoint with unforgettable sunrise views",
  },
  {
    title: "Lake View Trails",
    description:
      "Flowing tracks overlooking pristine volcanic lakes with cool air and reflective waters",
  },
  {
    title: "Tea Plantation Paths",
    description:
      "Fast, rolling sections through historic tea plantations offering rhythm and cultural charm",
  },
];

// EVENT SCHEDULE - JMM 2026
export const eventSchedule = [
  {
    title: "Race Pack Collection (TBD)",
    date: "24 & 25 April 2026",
    time: "12:00 - 17:00",
  },
  {
    title: "Start JMM 45K",
    date: "26 April 2026",
    time: "06:00",
  },
  {
    title: "Start JMM 25K",
    date: "26 April 2026",
    time: "07:00",
  },
  {
    title: "Start JMM 10K",
    date: "26 April 2026",
    time: "07:30",
  },
  {
    title: "Awarding Ceremony",
    date: "26 April 2026",
    time: "13:00",
  },
  {
    title: "Finish Line Closes",
    date: "26 April 2026",
    time: "15:00",
  },
];

// Intro / paragraph yang muncul di bawah title "Qualification & Race Inclusions"
export const qualificationIntro =
  "The following criteria and rules apply to all entrants. You must meet at least one of the following qualifying performances (times must be from an official race event; ITRA/UTMB index option is accepted only if the result from recognized races). We do not accept Strava times or personal GPS records.";

// PER-CATEGORY OVERRIDES
// Use exact categoryName from event.categories[].categoryName as key
export const qualificationByCategory = {
  "JMM 45K": [
    "Any 30 km trail running race, finished within the official cut-off time",
    "Any standard 42.2 km road marathon finished under 6:00 hours",
    "Any Ironman-distance triathlon run leg (42.2 km) finished under 7:00 hours",
    "An ITRA or UTMB index greater than 300",
  ],
  "JMM 25K": [
    "Any 15 km trail running race, finished within the official cut-off time",
    "Any standard 21.1 km road marathon finished within the official cut-off time",
  ],
  "JMM 10K": [
    "No qualification is required, but you must consider the nature of terrain and weather and you must be in good physical condition.",
  ],
  "JMM UP": [
    "Any 15 km trail running race, finished within the official cut-off time",
    "Any standard 21.1 km road marathon finished within the official cut-off time",
  ],
};

export const raceInclusionsByCategory = {
  "JMM 45K": [
    "Race Bib Number",
    "Finisher Medal",
    "Race Jersey",
    "Refreshments",
  ],
  "JMM 25K": [
    "Race Bib Number",
    "Finisher Medal",
    "Race Jersey",
    "Refreshments",
  ],
  "JMM 10K": [
    "Race Bib Number",
    "Finisher Medal",
    "Race Jersey",
    "Refreshments",
  ],
  "JMM UP": [
    "Race Bib Number",
    "Finisher Medal",
    "Race Jersey",
    "Refreshments",
  ],
};

// Global fallback defaults
export const qualification = [
  "Please refer to specific category requirements.",
];

export const raceInclusions = [
  "Race Bib Number",
  "Finisher Medal",
  "Race Jersey",
];

// JMM Mandatory Gears - 3 KATEGORI: JMM 45K, JMM 25K, JMM 10K
export const mandatoryGearsJMM = {
  "JMM 45K": [
    { gear: "Running Vest/Belt", mandatory: true, recommended: false },
    {
      gear: "Mobile Phone with GPX Route",
      mandatory: true,
      recommended: false,
    },
    { gear: "Smartwatch", mandatory: false, recommended: true },
    {
      gear: "Minimum Water Supply of 500ml",
      mandatory: true,
      recommended: false,
    },
    { gear: "Foldable Cup", mandatory: true, recommended: false },
    { gear: "Survival Blanket", mandatory: true, recommended: false },
    { gear: "First Aid Kits", mandatory: true, recommended: false },
    { gear: "Snack/Energy Bar", mandatory: true, recommended: false },
    { gear: "Windproof Jacket", mandatory: true, recommended: false },
    { gear: "Rainproof Jacket/Poncho", mandatory: true, recommended: false },
    { gear: "ID Card", mandatory: true, recommended: false },
    { gear: "Whistle", mandatory: true, recommended: false },
    { gear: "Headlamp", mandatory: true, recommended: false },
    { gear: "Cap/Bandana", mandatory: false, recommended: true },
    { gear: "Running Shoes", mandatory: true, recommended: false },
    { gear: "Sufficient Cash", mandatory: false, recommended: true },
    { gear: "Trekking Poles", mandatory: true, recommended: false },
  ],
  "JMM 25K": [
    { gear: "Running Vest/Belt", mandatory: true, recommended: false },
    {
      gear: "Mobile Phone with GPX Route",
      mandatory: true,
      recommended: false,
    },
    { gear: "Smartwatch", mandatory: false, recommended: true },
    {
      gear: "Minimum Water Supply of 500ml",
      mandatory: true,
      recommended: false,
    },
    { gear: "Foldable Cup", mandatory: true, recommended: false },
    { gear: "Survival Blanket", mandatory: false, recommended: true },
    { gear: "First Aid Kits", mandatory: true, recommended: false },
    { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
    { gear: "Windproof Jacket", mandatory: false, recommended: true },
    { gear: "Rainproof Jacket/Poncho", mandatory: true, recommended: false },
    { gear: "ID Card", mandatory: true, recommended: false },
    { gear: "Whistle", mandatory: true, recommended: false },
    { gear: "Headlamp", mandatory: true, recommended: false },
    { gear: "Cap/Bandana", mandatory: false, recommended: true },
    { gear: "Running Shoes", mandatory: true, recommended: false },
    { gear: "Sufficient Cash", mandatory: false, recommended: true },
    { gear: "Trekking Poles", mandatory: false, recommended: true },
  ],
  "JMM 10K": [
    { gear: "Running Vest/Belt", mandatory: false, recommended: true },
    {
      gear: "Mobile Phone with GPX Route",
      mandatory: false,
      recommended: true,
    },
    { gear: "Smartwatch", mandatory: false, recommended: true },
    {
      gear: "Minimum Water Supply of 500ml",
      mandatory: true,
      recommended: false,
    },
    { gear: "Foldable Cup", mandatory: false, recommended: true },
    { gear: "Survival Blanket", mandatory: false, recommended: true },
    { gear: "First Aid Kits", mandatory: true, recommended: false },
    { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
    { gear: "Windproof Jacket", mandatory: false, recommended: true },
    { gear: "Rainproof Jacket/Poncho", mandatory: false, recommended: true },
    { gear: "ID Card", mandatory: true, recommended: false },
    { gear: "Whistle", mandatory: true, recommended: false },
    { gear: "Headlamp", mandatory: false, recommended: true },
    { gear: "Cap/Bandana", mandatory: false, recommended: true },
    { gear: "Running Shoes", mandatory: true, recommended: false },
    { gear: "Sufficient Cash", mandatory: false, recommended: true },
    { gear: "Trekking Poles", mandatory: false, recommended: true },
  ],
  "JMM UP": [
    { gear: "Running Vest/Belt", mandatory: false, recommended: true },
    {
      gear: "Mobile Phone with GPX Route",
      mandatory: false,
      recommended: true,
    },
    { gear: "Smartwatch", mandatory: false, recommended: true },
    {
      gear: "Minimum Water Supply of 500ml",
      mandatory: true,
      recommended: false,
    },
    { gear: "Foldable Cup", mandatory: false, recommended: true },
    { gear: "Survival Blanket", mandatory: false, recommended: true },
    { gear: "First Aid Kits", mandatory: true, recommended: false },
    { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
    { gear: "Windproof Jacket", mandatory: false, recommended: true },
    { gear: "Rainproof Jacket/Poncho", mandatory: false, recommended: true },
    { gear: "ID Card", mandatory: true, recommended: false },
    { gear: "Whistle", mandatory: true, recommended: false },
    { gear: "Headlamp", mandatory: false, recommended: true },
    { gear: "Cap/Bandana", mandatory: false, recommended: true },
    { gear: "Running Shoes", mandatory: true, recommended: false },
    { gear: "Sufficient Cash", mandatory: false, recommended: true },
    { gear: "Trekking Poles", mandatory: false, recommended: true },
  ],
};

// Function untuk mendapatkan gear icon
export const getGearIcon = (gearName) => {
  const gearIconMap = {
    "running vest/belt": "/gears/01.svg",
    "mobile phone with gpx route": "/gears/02.svg",
    smartwatch: "/gears/03.png",
    "minimum water supply of 500ml": "/gears/04.svg",
    "foldable cup": "/gears/05.svg",
    "survival blanket": "/gears/06.svg",
    "first aid kits": "/gears/07.svg",
    "snack/energy bar": "/gears/08.svg",
    "windproof jacket": "/gears/09.svg",
    "rainproof jacket/poncho": "/gears/10.svg",
    "id card": "/gears/11.svg",
    whistle: "/gears/12.svg",
    headlamp: "/gears/13.svg",
    "cap/bandana": "/gears/14.svg",
    "running shoes": "/gears/15.png",
    "sufficient cash": "/gears/16.svg",
    "trekking poles": "/gears/17.png",
  };
  return gearIconMap[gearName.toLowerCase()] || "/gears/default-gear.svg";
};

// Component untuk CheckCircle
export const CheckCircle = () => (
  <span
    className="inline-flex items-center justify-center text-red-600 flex-shrink-0"
    aria-hidden="true"
  >
    <FontAwesomeIcon icon={faCheck} className="text-sm" />
  </span>
);

export const JMMDetail = () => {
  return <div>{/* Your updated JMMDetail content */}</div>;
};
